import { authorCourse, terrainPreset, type HolePlan } from './courseAuthoring';
import { plans } from './coursePlans';
export const redstoneCanyonMetadata = {
  id: 'redstone-canyon',
  name: 'Redstone Canyon',
  description: 'A firm desert-canyon course threading red-rock openings and dry washes.',
  environmentPreset: 'desert-sunset',
  metadata: {
    location: 'Redstone, Arizona',
    regionType: 'desert canyon',
    difficulty: 84,
    typicalWind: [7, 17] as const,
    greenSpeed: [10.5, 11.5] as const,
    firmness: 'firm' as const,
    primaryChallenge: 'Forced carries, rock collision, canyon banks and punishing recovery',
    signatureHoles: [2, 6, 13, 18],
    tournamentEventId: 'event-8',
    previewTheme: 'red-rock-canyon',
    environmentPalette: {
      fairway: '#768555',
      rough: '#9b573c',
      bunker: '#d18b5b',
      water: '#537a82',
      haze: '#d79b78',
    },
    vegetationStyle: 'sparse juniper and desert scrub',
    terrainStyle: terrainPreset('canyon-walls', 18, 95, 1.5).id,
  },
};
const pars = [4, 4, 5, 3, 4, 3, 4, 5, 4, 4, 4, 3, 5, 4, 4, 3, 4, 4];
const yards = [
  420, 445, 540, 165, 460, 410, 205, 575, 390, 455, 430, 180, 520, 440, 400, 210, 465, 470,
];
const names = [
  'Mesa',
  'Rock Gate',
  'Dry River',
  'Canyon Wedge',
  'Red Wall',
  'Echo',
  'Shelf',
  'Wash Gamble',
  'Juniper',
  'Hardpan',
  'Narrows',
  'Copper Bowl',
  'Carry the Wash',
  'Bank Shot',
  'Desert Line',
  'Chasm',
  'Red Horizon',
  'Stone Corridor',
];
const options: Partial<HolePlan>[] = [];
options[1] = { rocks: 8, landingZones: [{ distance: 260, width: 30 }] };
options[5] = { rocks: 7, greenRadius: 14 };
options[12] = { water: 'carry', rocks: 5 };
options[17] = { rocks: 10, landingZones: [{ distance: 275, width: 28 }] };
export const createRedstoneCanyonDocument = () =>
  authorCourse({
    ...redstoneCanyonMetadata,
    plans: plans(names, pars, yards, options).map((p) => ({
      ...p,
      trees: p.trees ?? 1,
      rocks: p.rocks ?? 4,
    })),
  });
